import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl-next';
import Avatar from '@atlaskit/avatar';
import Button from '@atlaskit/button/standard-button';
import { Checkbox } from '@atlaskit/checkbox';
import { useFlags } from '@atlaskit/flag';
import ArrowRightIcon from '@atlaskit/icon/glyph/arrow-right';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import { LoadingSpinner } from '@atlassian/proforma-common-core/jira-common';
import { useInProductHelp } from '@atlassian/proforma-common-core/jira-common-context';
import { useProjectFormsControllerActions } from '../../../../../../controllers';
import { useProjectApi } from '../../../../../../services/project-api';
import { useTemplateFormApi } from '../../../../../../services/template-form-api';
import { messages } from './messages';
import { Divider, FormNameContainer, LeftPanel, ModalTitleContainer, PanelContainer, ProjectLabelContainer, ProjectNameContainer, ProjectsContainer, RightPanel } from './styled';
import { onCopyClick } from './utils';
export const CopyProjectFormModal = ({
  onClose,
  formToCopy
}) => {
  const {
    showFlag
  } = useFlags();
  const {
    simplifiedProject,
    onOpenInProductHelpArticle
  } = useInProductHelp();
  const projectApi = useProjectApi();
  const [, {
    load
  }] = useProjectFormsControllerActions();
  const templateFormApi = useTemplateFormApi();
  const [projects, setProjects] = useState([]);
  const [isLoadingProjects, setIsLoadingProjects] = useState(true);
  const handleCopy = () => onCopyClick(formToCopy, projects, templateFormApi, showFlag, load, onClose);
  useEffect(() => {
    projectApi.getAllProjects().then(newProjects => {
      const projectsWithSelectedState = newProjects.sort((projectA, projectB) =>
      // The current project should be listed first:
      projectA.id === formToCopy.projectId ? -1 : projectB.id === formToCopy.projectId ? 1 : projectA.name.localeCompare(projectB.name)).map(project => ({
        ...project,
        selected: false
      }));
      setProjects(projectsWithSelectedState);
      setIsLoadingProjects(false);
    });
  }, [formToCopy.projectId, projectApi]);
  const handleSelectProject = projectId => {
    const newProjects = [...projects];
    const projectIndex = newProjects.findIndex(project => project.id === projectId);
    if (projectIndex !== -1) {
      newProjects[projectIndex].selected = !newProjects[projectIndex].selected;
    }
    setProjects(newProjects);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    onClose: onClose,
    width: "large"
  }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(ModalTitleContainer, null, /*#__PURE__*/React.createElement(ModalTitle, null, /*#__PURE__*/React.createElement(FormattedMessage, _extends({}, messages.heading, {
    values: {
      formName: formToCopy.name
    }
  }))))), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedMessage, messages.subHeading), ' ', /*#__PURE__*/React.createElement(Button, {
    appearance: "link",
    spacing: "none",
    onClick: () => onOpenInProductHelpArticle(simplifiedProject ? '2UpZYTmtNjy287pvVmqg8Z' : '4lpdE2uEWCBRuduqNGgLLs')
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.learnMore))), /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(PanelContainer, null, /*#__PURE__*/React.createElement(LeftPanel, null, /*#__PURE__*/React.createElement(PanelTitle, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.name)), /*#__PURE__*/React.createElement(FormNameContainer, null, /*#__PURE__*/React.createElement("span", null, formToCopy.name), /*#__PURE__*/React.createElement(ArrowRightIcon, {
    label: "Right arrow icon"
  }))), /*#__PURE__*/React.createElement(RightPanel, null, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", null, /*#__PURE__*/React.createElement(PanelTitle, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.copyToProjectsTitle))), /*#__PURE__*/React.createElement(ProjectsContainer, null, isLoadingProjects ? /*#__PURE__*/React.createElement(LoadingSpinner, {
    size: "large"
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.loadingProjects)) : projects.map(project => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Checkbox, {
    value: project.id,
    size: "large",
    label: /*#__PURE__*/React.createElement(ProjectLabelContainer, null, /*#__PURE__*/React.createElement(Avatar, {
      appearance: "square",
      size: "small",
      src: project.smallAvatarUrl,
      name: project.name
    }), /*#__PURE__*/React.createElement(ProjectNameContainer, null, project.name)),
    isChecked: project.selected,
    onChange: () => handleSelectProject(project.id),
    name: project.name
  }))))))), /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    onClick: onClose
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.cancel)), /*#__PURE__*/React.createElement(Button, {
    appearance: "primary",
    onClick: handleCopy
  }, /*#__PURE__*/React.createElement(FormattedMessage, messages.copy))));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const PanelTitle = styled.h2({
  fontSize: "var(--ds-font-body, 14px)",
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  letterSpacing: '-0.003em',
  paddingTop: "var(--ds-space-200, 16px)"
});